import { getNightsInRange } from 'src/utils/date'
import { isWeekend } from 'date-fns'
import './../../../../../../sinapsi/style/price-calendar.sinapsi.css'
import './style/rr-bulk-edit-cc.css'
import { ReservedResourceF } from '../../../../types/reservation-detail.types'
import RRBulkEditChargeCategoriesGridFirstCell from './cell/rr-bulk-edit-charge-categories-grid-first-cell'
import RRBulkEditChargeCategoryGridCell from './cell/rr-bulk-edit-charge-category-grid-cell'
import RRBulkEditChargeCategoryGridHeader from './cell/rr-bulk-edit-charge-category-grid-header'
import RRBulkEditChargeCategoryGridFooterCell from './cell/rr-bulk-edit-charge-category-grid-footer-cell'
import { RRBulkEditCCGridRow, RRBulkEditCCSummaryRow } from './utils/rr-bulk-edit-cc-grid-rows'
import { ChargeCategoryFragment } from 'src/api/api.generated'

type RREditChargeCategoriesGridProps = {
  start: Date
  end: Date
  disabled: boolean
  propertyId: string
  reservedResources: ReservedResourceF[]
  chargeCategories: ChargeCategoryFragment[]
  rows: RRBulkEditCCGridRow[]
  summaryRow?: RRBulkEditCCSummaryRow
  updateRow: (rowId: string, day: Date, selectedCCId: string | undefined) => void
  updateRows: (day: Date, selectedCCId: string | undefined) => void
}

export default function RREditChargeCategoriesGrid(props: RREditChargeCategoriesGridProps) {
  const { start, end, disabled, reservedResources, chargeCategories, rows, summaryRow, updateRow, updateRows } = props

  return (
    <div className="container">
      <table className="table">
        <thead>
          <tr>
            <th className="rr-cell sticky sticky-white-space">{/* for accommodation name */}</th>
            {getNightsInRange(start, end).map((day) => {
              return (
                <th className={`rr-cell sticky sticky-header ${isWeekend(day) ? 'weekend' : ''}`} key={day.getTime()}>
                  <RRBulkEditChargeCategoryGridHeader reservedResources={reservedResources} day={day} chargeCategories={chargeCategories} updateRowsChargeCategory={updateRows} />
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            return (
              <tr key={r.id}>
                <td className="sticky sticky-column rr-cell">
                  <RRBulkEditChargeCategoriesGridFirstCell reservedResource={r.reservedResource} />
                </td>
                {r.chargeCategoriesPerDay.map((ccPerDay, index) => {
                  return (
                    <td key={index} className="rr-cell">
                      {ccPerDay && (
                        <RRBulkEditChargeCategoryGridCell
                          chargeCategories={chargeCategories.filter((cc) => r.reservedResource.rate.chargesRate?.map((cr) => cr.chargeCategoryId).includes(cc.id))}
                          disabled={disabled}
                          initialValue={ccPerDay.initialChargeCategoryId}
                          value={ccPerDay.chargeCategoryId}
                          onChange={(value) => updateRow(r.id, ccPerDay.day, value)}
                        />
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="sticky sticky-column rr-cell"></td>
            {summaryRow?.columnsSummaries.map((colSum) => {
              return (
                <td className="rr-cell" key={colSum.day.getTime()}>
                  <RRBulkEditChargeCategoryGridFooterCell dayChargeCategories={colSum.summary} />
                </td>
              )
            })}
          </tr>
        </tfoot>
      </table>
    </div>
  )
}
